import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
  selector: 'review-score',
  template: `
    <div *ngIf="score" class="-eva-3-valign">
      <div class="eva-3-rating {{size}} {{reviewClassName}}">
        <span class="rating-text">{{score}}</span>
      </div>
      <span *ngIf="overallRatingDescription" class="-eva-3-ml-sm {{overallRatingDescriptionStyle}} eva-3-h6">{{overallRatingDescription}}</span>
    </div>
  `,
  encapsulation: ViewEncapsulation.None
})

export class ReviewScoreComponent implements OnInit {

  @Input() score: string;
  @Input() size?: '-sm' | '-md' | '-lg' = '-sm';
  @Input() overallRatingDescription?: string;
  @Input() overallRatingDescriptionStyle?: string;
  reviewClassName: string;

  ngOnInit(): void {
    const scoreNumber = parseInt(this.score);
    this.reviewClassName = scoreNumber < 4 ? '-bad' : scoreNumber < 7 ? '-regular' : '-good';
  }
}
